import { navigate } from "./router.js";
import { useSessions } from "./services.js";
import type { SessionStore } from "./session.js";

export function signOut(sessions: SessionStore): void {
  sessions.clear();
  navigate("/login", { replace: true });
}

export function SignOutButton() {
  const sessions = useSessions();
  return (
    <button type="button" className="nav-signout" onClick={() => { signOut(sessions); }}>
      Sign out
    </button>
  );
}
